//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { putObj } from "@/api/admin/dict";
export default {
  props: {
    editData: {
      type: Object,
      required: true
    }
  },
  components: {},
  data: function data() {
    return {
      ruleData: null,
      subDisabled: false,
      formValidate: {
        id: null,
        value: "",
        type: "",
        label: "",
        description: "",
        remarks: "",
        sort: 0,
        sysFlag: 0
      },
      // 表单数据绑定
      ruleValidate: {
        type: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 80,
          message: "长度在 1 到 80 个字符",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 80,
          message: "长度在 1 到 80 个字符",
          trigger: "blur"
        }],
        remarks: [{
          required: false,
          message: "",
          trigger: "blur"
        }, {
          min: 1,
          max: 200,
          message: "长度在 1 到 200 个字符",
          trigger: "blur"
        }]
      } // 表单验证

    };
  },
  computed: {},
  methods: {
    showEditData: function showEditData() {
      this.formValidate = this.editData.data;
      this.ruleData = this.editData.data;
    },
    closeModal: function closeModal() {
      this.$emit("closeEdit", {
        state: false
      });
      this.editData.state = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.subDisabled = true;
          putObj(_this.formValidate).then(function (res) {
            if (res.data.code == 0) {
              _this.subDisabled = false;

              _this.closeModal();
            } else {
              _this.subDisabled = false;

              _this.$alert(res.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.closeModal();
    }
  }
};